import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';
import { AirportService } from '../../airport/airport.service';
var SelectMagazineDialogComponent = /** @class */ (function () {
    function SelectMagazineDialogComponent(_dialogRef, data, _airportService, _businessManagerService, _tagService, _snackBar) {
        this._dialogRef = _dialogRef;
        this.data = data;
        this._airportService = _airportService;
        this._businessManagerService = _businessManagerService;
        this._tagService = _tagService;
        this._snackBar = _snackBar;
        this.isLoading = false;
        this.business = data.business;
    }
    SelectMagazineDialogComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, startingMag;
            var _this = this;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        this.isLoading = true;
                        _a = this;
                        return [4 /*yield*/, this._airportService.getBusiness(this.business.id.toString())];
                    case 1:
                        _a.business = _g.sent();
                        _b = this;
                        return [4 /*yield*/, this._tagService.getAllTags()];
                    case 2:
                        _b.allTags = _g.sent();
                        _c = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Magazine::No Magazine')];
                    case 3:
                        _c.NoMagTag = _g.sent();
                        this.getsNoMagazine = hasTag(this.business.tags, 'Magazine::No Magazine');
                        _d = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Magazine::Flight Training')];
                    case 4:
                        _d.FTMagTag = _g.sent();
                        this.getsFTMagazine = hasTag(this.business.tags, 'Magazine::Flight Training');
                        _e = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Magazine::AOPA Pilot')];
                    case 5:
                        _e.PilotMagTag = _g.sent();
                        this.getsPilotMagazine = hasTag(this.business.tags, 'Magazine::AOPA Pilot');
                        _f = this;
                        return [4 /*yield*/, this._tagService.findTagByName(this.allTags, 'Magazine::AOPA Turbine Pilot')];
                    case 6:
                        _f.TurbinePilotMagTag = _g.sent();
                        this.getsTurbinePilotMagazine = hasTag(this.business.tags, 'Magazine::AOPA Turbine Pilot');
                        if (this.getsNoMagazine) {
                            this.currentMag = 'NoMag';
                        }
                        else if (this.getsFTMagazine) {
                            this.currentMag = 'AOPAFlightTraining';
                        }
                        else if (this.getsPilotMagazine) {
                            this.currentMag = 'AOPAPilot';
                        }
                        else if (this.getsTurbinePilotMagazine) {
                            this.currentMag = 'AOPATurbinePilot';
                        }
                        startingMag = 'NoMag';
                        if (this.currentMag) {
                            startingMag = this.currentMag;
                        }
                        this.formGroup = new FormGroup({
                            magType: new FormControl(startingMag, [Validators.required])
                        });
                        this._dialogRef.backdropClick().subscribe(function () {
                            var CLOSE_DIALOG = new CloseDialog();
                            CLOSE_DIALOG.cancelButtonClicked = true;
                            _this._dialogRef.close(CLOSE_DIALOG);
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SelectMagazineDialogComponent.prototype.onSubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CLOSE_DIALOG, ERROR_MSG, BUSINESS_ID, deleteTagID, TAG_ID, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        CLOSE_DIALOG = new CloseDialog();
                        ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
                        BUSINESS_ID = this.business.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        deleteTagID = void 0;
                        if (this.currentMag === 'NoMag') {
                            deleteTagID = this.NoMagTag.tagId;
                        }
                        else if (this.currentMag === 'AOPAFlightTraining') {
                            deleteTagID = this.FTMagTag.tagId;
                        }
                        else if (this.currentMag === 'AOPAPilot') {
                            deleteTagID = this.PilotMagTag.tagId;
                        }
                        else if (this.currentMag === 'AOPATurbinePilot') {
                            deleteTagID = this.TurbinePilotMagTag.tagId;
                        }
                        if (!deleteTagID) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.deleteTag(deleteTagID, BUSINESS_ID)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        TAG_ID = void 0;
                        if (this.formGroup.controls['magType'].value === 'NoMag') {
                            TAG_ID = this.NoMagTag.tagId;
                        }
                        else if (this.formGroup.controls['magType'].value === 'AOPAFlightTraining') {
                            TAG_ID = this.FTMagTag.tagId;
                        }
                        else if (this.formGroup.controls['magType'].value === 'AOPAPilot') {
                            TAG_ID = this.PilotMagTag.tagId;
                        }
                        else if (this.formGroup.controls['magType'].value === 'AOPATurbinePilot') {
                            TAG_ID = this.TurbinePilotMagTag.tagId;
                        }
                        return [4 /*yield*/, this._tagService.postTag(TAG_ID, BUSINESS_ID)];
                    case 4:
                        _a.sent();
                        this._snackBar.open('Magazine selection successfully saved.', 'Note', {
                            duration: 6000
                        });
                        CLOSE_DIALOG.success = true;
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        throw e_1;
                    case 6:
                        this._dialogRef.close(CLOSE_DIALOG);
                        return [2 /*return*/];
                }
            });
        });
    };
    return SelectMagazineDialogComponent;
}());
export { SelectMagazineDialogComponent };
